import { initializeApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getAnalytics, isSupported } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyAfYQe8o8Z6-z5InjnvvvV8TKYVNhUxABU",
  authDomain: "ridebase-console.firebaseapp.com",
  projectId: "ridebase-console",
  storageBucket: "ridebase-console.firebasestorage.app",
  messagingSenderId: "95850394102",
  appId: "1:95850394102:web:2f803c18d7a695fa5c57d7",
  measurementId: "G-XMBXYR5CRD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firebase Authentication
export const auth: Auth = getAuth(app);

// ✅ Analytics (safe for all browsers)
export const analyticsPromise = isSupported().then((supported) =>
  supported ? getAnalytics(app) : null
);

// Default export the app
export default app;